import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_search_btn = _resolveComponent("create-search-btn")!
  const _component_post_searches_table = _resolveComponent("post-searches-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_create_search_btn, {
      "client-id": _ctx.clientId,
      onCreated: _ctx.prepend
    }, null, 8, ["client-id", "onCreated"]),
    _createVNode(_component_post_searches_table, {
      "client-id": _ctx.clientId,
      ref: "searches"
    }, null, 8, ["client-id"])
  ]))
}